/**
 * Exception to indicate a browser redirect must occur
 */
export default class {
  /**
   * Create a new redirect exception
   *
   * @param {String} message Exception message
   */
  constructor(message = '') {
    this.message = message;
  }
}
